import api from "./api";

class WorkOrderService {
    listWorkOrders(params = {}) {
        return api.get("/api/manufacturing/work-orders/", { params });
    }

    getWorkOrder(id) {
        return api.get(`/api/manufacturing/work-orders/${id}/`);
    }

    listTravelers(workOrderId) {
        return api.get("/api/manufacturing/work-travelers/", {
            params: { work_order: workOrderId },
        });
    }

    getTravelerByToken(token) {
        return api.get(`/api/manufacturing/work-travelers/by-token/${encodeURIComponent(token)}/`);
    }

    resolvedPreview(id) {
        return api.get(`/api/manufacturing/work-orders/${id}/resolved-preview/`);
    }

    startTraveler(id) {
        return api.post(`/api/manufacturing/work-travelers/${id}/start/`);
    }

    submitTraveler(id) {
        return api.post(`/api/manufacturing/work-travelers/${id}/submit/`);
    }

    completeTraveler(id, payload = {}) {
        return api.post(`/api/manufacturing/work-travelers/${id}/complete/`, payload);
    }

    unapproveTraveler(id) {
        return api.post(`/api/manufacturing/work-travelers/${id}/unapprove/`);
    }

    failInspectionTraveler(id, notes = "") {
        return api.post(`/api/manufacturing/work-travelers/${id}/fail-inspection/`, { notes });
    }

    logTravelerTime(id, payload = {}) {
        return api.post(`/api/manufacturing/work-travelers/${id}/log-time/`, payload);
    }

    archive(id) {
        return api.post(`/api/manufacturing/work-orders/${id}/archive/`);
    }

    unarchive(id) {
        return api.post(`/api/manufacturing/work-orders/${id}/unarchive/`);
    }
}

export default new WorkOrderService();
